module.exports = __webpack_public_path__ + "img/1.51706c53.png";